<template>
    <vs-popup :title="$t('image_preview')" :active.sync="popupActive">
        <img v-if="selectImage" :src="selectImage.path" :alt="selectImage.name" class="resp_img" />
    </vs-popup>
</template>

<script>
import {mapState} from 'vuex'
export default {
    computed: {
        ...mapState({
            selectImage: state => state.chat.selectImage
        }),
        linkReplace() {
            if(this.selectImage.file.indexOf('acc.gos24.kz') !== -1)
                return this.selectImage.file
            else
                return 'https://acc.gos24.kz' + this.selectImage.file
        },
        popupActive: {
            get() {
                return this.$store.state.chat.imagePopup
            },
            set(val) {
                this.$store.commit('chat/SET_IMAGE_POPUP', val)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.resp_img{
    max-width: 100%;
}
</style>
